import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import zoneLocalStorageId from "utils/zone";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

export const fetchMachineMaster = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS,
) => {
  return axiosInstance.get(EndPoints.MACHINE_MASTER.LIST, {
    params: {
      limit,
      page_no,
      zone_id: zoneLocalStorageId(),
      ...filter,
    },
  });
};

export const createMachineMaster = (payload) => {
  return axiosInstance.post(EndPoints.MACHINE_MASTER.CREATE, payload);
};

export const updateMachineMaster = (payload) => {
  return axiosInstance.put(EndPoints.MACHINE_MASTER.UPDATE, payload);
};

export const deleteMachineMaster = (payload) => {
  const url = EndPoints.MACHINE_MASTER.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadMachineMasterCSV = () => {
  return axiosInstance.put(EndPoints.MACHINE_MASTER.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
